<template>
  <div class="pt-3">
    <div
      v-if="listing && catalogDetails.productCategory === 'Courses'"
      class="d-flex mb-3 tab-bar"
    >
      <div
        class="tab-item"
        :class="{ active: activeTab === 'details' }"
        @click="activeTab = 'details'"
      >
        Szczegóły
      </div>
      <div
        v-if="catalogDetails.productCategory === 'Courses'"
        class="tab-item"
        :class="{ active: activeTab === 'schedule' }"
        @click="
          activeTab = 'schedule';
          loadRules();
        "
      >
        Harmonogram
      </div>
    </div>

    <div v-if="listing && activeTab === 'schedule'">
      <div
        v-if="addingRule || editingRule"
        class="mb-3"
      >
        <CalendarRuleForm
          :catalog-id="catalogDetails.id"
          :init-hour="9"
          :offer-id="listing.id"
          :rule="editingRule"
          :edit-mode="true"
          @cancel="cancelRuleEdit"
          @refresh="
            loadRules();
            editingRule = null;
          "
        />
      </div>
      <template v-else>
        <div
          v-if="rulesError"
          class="alert alert-danger d-flex align-items-center justify-content-between py-2 px-3 mb-2"
        >
          <span>Nie udało się pobrać reguł harmonogramu</span>
          <i
            class="fas fa-rotate-right ml-2"
            style="cursor: pointer"
            @click="loadRules"
          />
        </div>
        <template v-else>
          <div
            v-for="rule in listingRules"
            :key="rule.id"
            class="rule-row"
          >
            <div class="d-flex justify-content-between align-items-center">
              <div>
                <span class="font-weight-bold mr-2">{{ formatWeekDay(rule.weekDay) }}</span>
                <span class="text-secondary">
                  {{ formatHour(rule.startMinutes) }} – {{ formatHour(rule.startMinutes + rule.durationMinutes) }}
                </span>
              </div>
              <div class="d-flex">
                <i
                  class="fas fa-pen secondary-icon mr-2"
                  @click="editingRule = rule"
                />
                <i
                  class="fas fa-trash secondary-icon"
                  @click="removeRule(rule)"
                />
              </div>
            </div>
            <div
              v-if="rule.comment"
              class="small text-muted mt-1"
            >
              {{ rule.comment }}
            </div>
          </div>
          <div
            v-if="listingRules.length === 0 && !rulesPending"
            class="text-secondary small mb-3"
          >
            Brak reguł harmonogramu
          </div>
        </template>
        <button
          class="btn btn-outline-primary btn-sm mt-2"
          :disabled="rulesError"
          @click="addingRule = true"
        >
          <i class="fas fa-plus mr-1" />
          Dodaj regułę
        </button>
      </template>
    </div>

    <div v-show="!listing || activeTab === 'details'">
      <div class="form-group">
        <label for="paymentTitle">{{ $t('general.name') }}</label>
        <input
          v-model="name"
          class="form-control"
          :placeholder="$t('general.name')"
        >
      </div>
      <div class="form-group">
        <label for="paymentTitle">{{ $t('general.description') }}</label>
        <RichTextEditor
          v-model="description"
          :placeholder="$t('general.description')"
          :min-height="160"
          :max-height="360"
        />
      </div>

      <div
        v-for="field in catalogDetails.listingFields"
        :key="field.id"
        class="mb-3 form-box"
      >
        <div class="d-flex justify-content-between">
          <label class="section-title mb-2">
            {{ field.name }}
          </label>
        </div>
        <div>
          <input
            class="form-control"
            :placeholder="field.name"
            :value="fields[field.fieldId]"
            @input="fields[field.fieldId] = $event.target.value"
          >
        </div>
        <!-- <div class="form-group">
        <label for="paymentTitle">{{ field.name }}</label>
        <input
          v-model="field.value"
          class="form-control"
          :placeholder="field.name"
        >
      </div> -->
      </div>

      <div
        v-for="subCatalog in subCatalogsSorted"
        :key="subCatalog.subCatalogId"
        class="mb-3 form-box"
      >
        <div class="d-flex justify-content-between">
          <label class="section-title mb-2">
            {{ subCatalog.name }}
          </label>
          <AssignSubCatalogDropdown
            :sub-catalog-id="subCatalog.subCatalogId"
            :selected.sync="assignments"
          />
        </div>
        <div class="px-2 first">
          <div
            v-for="node in subCatalog.nodes"
            :key="node.nodeId"
            class="product-row"
          >
            <i
              class="fas fa-times secondary-icon"
              @click="removeNode(node.nodeId)"
            />
            <span class="font-weight-bold pl-2">
              {{ node.name }}
            </span>
          </div>

          <div v-if="subCatalog.nodes.length === 0">
            -
          </div>
        </div>
      </div>
      <div class="d-flex align-items-center mb-3">
        <div
          v-show="listing && listing.photoUrl"
          ref="photoWrapper"
          class="photo-wrapper"
        >
          <img
            v-show="!removePhoto"
            ref="photo"
            class="photo"
            :src="listing ? listing.photoUrl : ''"
          >
        </div>

        <div class="d-flex align-items-center mb-3 w-100">
          <div v-if="file || (listing && listing.photoUrl)">
            <i
              class="fas fa-times secondary-icon mr-2"
              @click="
                file = null;
                removePhoto = true;
              "
            />
          </div>
          <BFormFile
            v-model="file"
            :disabled="pending"
            accept="image/*"
            :browse-text="$t('shop.listing.browse')"
            :placeholder="$t('shop.listing.browsePlaceholder')"
          />
        </div>
      </div>

      <div class="d-flex align-items-center justify-content-between form-group">
        <label class="mb-0 mt-1">
          {{ $t('shop.price') }}
        </label>
        <MoneyInput
          v-model="price"
          :currency.sync="currency"
          class="money-input"
        />
      </div>

      <div
        v-if="catalogDetails.billPerListing"
        class="form-box mt-2 mb-3"
      >
        <label class="section-title mb-2 mt-1">
          {{ $t('shop.listing.billing') }}
        </label>
        <div class="form-group mb-2">
          <label class="small mb-1">{{ $t('shop.listing.priceType') }}</label>
          <BFormSelect
            v-model="priceType"
            :options="priceTypeOptions"
            size="sm"
          />
        </div>
        <div class="form-group mb-2">
          <label class="small mb-1">{{ $t('shop.listing.vatCode') }}</label>
          <BFormSelect
            v-model="vatCode"
            :options="vatCodeOptions"
            size="sm"
          />
        </div>
        <div class="form-group mb-2">
          <label class="small mb-1">{{ $t('shop.listing.accountingCode') }}</label>
          <BFormInput
            v-model="accountingCode"
            size="sm"
            :placeholder="$t('shop.listing.accountingCode')"
          />
        </div>
        <div class="form-group mb-2">
          <label class="small mb-1">{{ $t('bill.category') }}</label>
          <CategoryDropdown
            :selected="billingCategoryId"
            @update:selected="billingCategoryId = $event"
          />
        </div>
        <div class="form-group mb-0">
          <label class="small mb-1">{{ $t('payment.accountNumber') }}</label>
          <BFormSelect
            v-model="accountNumber"
            :options="sortedAccounts"
            size="sm"
          />
        </div>
      </div>

      <div class="form-box">
        <div class="d-flex justify-content-between">
          <label class="mb-0 mt-1">
            {{ $t('shop.products') }}
          </label>

          <ProductAddDropdown
            :allow-create="!listing"
            :selected.sync="productIds"
          />
        </div>
        <div>
          <div
            v-for="id in productIds"
            :key="id"
            class="product-row"
          >
            <i
              class="fas fa-times secondary-icon mr-2"
              @click="removeProduct(id)"
            />
            {{ productName(id) }}
          </div>
        </div>
      </div>

      <div class="form-box pt-2 mt-4">
        <div class="d-flex mt-1">
          <BFormCheckbox
            v-model="individualOrdersEnabled"
            switch
            class="switch white-switch white-switch-sm"
          />
          <label class="mb-0">
            <i class="far fa-square-1 mr-1" />
            {{ $t('shop.listing.individualOrders') }}
          </label>
        </div>
        <hr
          v-if="individualOrdersEnabled"
          class="my-2"
        >

        <div
          v-if="individualOrdersEnabled"
          class="pl-3"
        >
          <div class="d-flex my-1">
            <BFormCheckbox
              v-model="orderFromEnabled"
              switch
              class="switch white-switch white-switch-sm"
            />
            <label>
              {{ $t('shop.orderFrom') }}
            </label>
          </div>

          <TimeLimitInput
            v-if="orderFromEnabled"
            :value.sync="orderFrom"
            :single-order-schema="singleOrderSchema"
            :label="$t('shop.orderFrom')"
            default-reference="ListingMonthStart|0.09:00:00.false"
          />

          <hr class="mb-2">

          <div class="d-flex my-1">
            <BFormCheckbox
              v-model="orderToEnabled"
              switch
              class="switch white-switch white-switch-sm"
            />
            <label>
              {{ $t('shop.orderTo') }}
            </label>
          </div>

          <TimeLimitInput
            v-if="orderToEnabled"
            :value.sync="orderTo"
            :single-order-schema="singleOrderSchema"
            :label="$t('shop.orderTo')"
            default-reference="ListingMonthEnd|0.09:00:00.false"
          />

          <hr class="mb-2">

          <div class="d-flex my-1">
            <BFormCheckbox
              v-model="cancelToEnabled"
              switch
              class="switch white-switch white-switch-sm"
            />
            <label>
              {{ $t('shop.cancelTo') }}
            </label>
          </div>

          <TimeLimitInput
            v-if="cancelToEnabled"
            :value.sync="cancelTo"
            :single-order-schema="singleOrderSchema"
            :label="$t('shop.cancelTo')"
            default-reference="ListingDay|-1.22:00:00.false"
          />

          <hr class="mb-2">
        </div>
      </div>

      <div
        v-if="!singleOrderSchema"
        class="form-box mt-4 pt-2"
      >
        <div class="d-flex mt-1">
          <BFormCheckbox
            v-model="subscription.enabled"
            switch
            class="switch white-switch white-switch-sm"
          />
          <label class="mb-0">
            <i class="fas fa-repeat mr-1" />
            {{ $t('shop.subscription.subscription') }}
          </label>
        </div>
        <hr
          v-if="subscription.enabled"
          class="my-2"
        >
        <div
          v-if="subscription.enabled"
          class="pl-3"
        >
          <div class="d-flex my-1">
            <label>
              {{ $t('shop.subscription.applyAt') }}
            </label>
          </div>
          <TimeLimitInput
            :value.sync="subscription.applyAt"
            default-reference="ListingMonthStart|0.09:00:00.false"
            :allowed-types="['ListingMonthStart']"
          />
          <hr class="mb-2">

          <div class="d-flex my-1">
            <BFormCheckbox
              v-model="subscription.subscribeFromEnabled"
              switch
              class="switch white-switch white-switch-sm"
            />
            <label>
              {{ $t('shop.subscription.subscribeFrom') }}
            </label>
          </div>
          <TimeLimitInput
            v-if="subscription.subscribeFromEnabled"
            :value.sync="subscription.subscribeFrom"
            :single-order-schema="true"
          />
          <hr class="mb-2">

          <div class="d-flex my-1">
            <BFormCheckbox
              v-model="subscription.subscribeToEnabled"
              switch
              class="switch white-switch white-switch-sm"
            />
            <label>
              {{ $t('shop.subscription.subscribeTo') }}
            </label>
          </div>
          <TimeLimitInput
            v-if="subscription.subscribeToEnabled"
            :value.sync="subscription.subscribeTo"
            :single-order-schema="true"
          />
          <hr class="mb-2">

          <div class="d-flex my-1">
            <BFormCheckbox
              v-model="subscription.unsubscribeToEnabled"
              switch
              class="switch white-switch white-switch-sm"
            />
            <label>
              {{ $t('shop.subscription.unsubscribeTo') }}
            </label>
          </div>
          <TimeLimitInput
            v-if="subscription.unsubscribeToEnabled"
            :value.sync="subscription.unsubscribeTo"
            :single-order-schema="true"
          />
          <hr class="mb-2">

          <div class="d-flex align-items-center my-1">
            <label class="mb-0 mr-2"> {{ $t('shop.subscription.includeUntil') }}: </label>
            <span class="small"> 20. </span>
          </div>
        </div>
      </div>

      <div class="form-box mt-4">
        <div class="d-flex my-1">
          <BFormCheckbox
            v-model="limitCountEnabled"
            switch
            class="switch white-switch white-switch-sm"
          />
          <label>
            {{ $t('shop.listing.limitCount') }}
          </label>
        </div>
        <BFormInput
          v-if="limitCountEnabled"
          v-model="limitCount"
          type="number"
          :placeholder="$t('shop.listing.limitCount')"
        />

        <hr class="mb-2">

        <hr class="mb-2">
        <label class="small mb-1">{{ $t('shop.listing.form') }}</label>
        <BFormSelect
          v-model="formId"
          :options="formOptions"
          size="sm"
        />
      </div>

      <hr>
      <div>
        <SaveButton
          :pending="pending"
          @cancel="$emit('close')"
          @save="save"
        />
      </div>
    </div>
  </div>
</template>

<script>
import axios from '@/api/axios';
import SaveButton from '@/components/SaveButton';
import MoneyInput from '@/components/utils/MoneyInput';
import CategoryDropdown from '@/components/bills/form/CategoryDropdown';
import { mapActions, mapGetters } from 'vuex';
import CalendarRuleForm from '@/components/shop/calendar/CalendarRuleForm';
import RichTextEditor from '@/components/editor/RichTextEditor';
import { vatCodeOptions } from '@/utils/vat';
import TimeLimitInput from '../TimeLimitInput';
import AssignSubCatalogDropdown from './AssignSubCatalogDropdown';
import ProductAddDropdown from './ProductAddDropdown';

export default {
  props: {
    listing: Object,
  },
  data: () => ({
    activeTab: 'details',
    listingRules: [],
    rulesPending: false,
    rulesError: false,
    addingRule: false,
    editingRule: null,
    edit: false,
    name: '',
    description: '',
    price: 0,
    currency: 'pln',
    pending: false,
    productIds: [],
    assignments: [],
    subscription: {
      enabled: false,
      subscribeToEnabled: false,
      subscribeFromEnabled: false,
      unsubscribeToEnabled: false,
      subscribeTo: '',
      applyAt: 'ListingMonthStart|0.09:00:00.false',
      includeUntilEnabled: false,
      includeUntil: '',
    },
    orderFrom: '',
    orderTo: '',
    cancelTo: '',
    limitCount: -1,
    orderFromEnabled: false,
    orderToEnabled: false,
    cancelToEnabled: false,
    limitCountEnabled: false,
    removePhoto: false,
    formId: null,
    forms: [],
    file: null,
    fields: {},
    priceType: 'Total',
    vatCode: null,
    accountingCode: '',
    billingCategoryId: null,
    accountNumber: null,
    vatCodeOptions,
  }),
  components: {
    CalendarRuleForm,
    RichTextEditor,
    CategoryDropdown,
    TimeLimitInput,
    ProductAddDropdown,
    AssignSubCatalogDropdown,
    MoneyInput,
    SaveButton,
  },
  computed: {
    ...mapGetters(['groups', 'bankAccounts']),
    ...mapGetters('shop', ['products', 'catalogDetails', 'singleOrderSchema']),
    formOptions() {
      return [{ value: null, text: '-' }, ...this.forms.map((f) => ({ value: f.id, text: f.name }))];
    },
    priceTypeOptions() {
      return [
        { value: 'Total', text: this.$t('shop.listing.priceTypes.total') },
        { value: 'ForEvent', text: this.$t('shop.listing.priceTypes.forEvent') },
        { value: 'ForParticipation', text: this.$t('shop.listing.priceTypes.forParticipation') },
      ];
    },
    sortedAccounts() {
      return [
        { value: null, text: '-' },
        ...this.bankAccounts.map((x) => ({ text: x.name, value: x.accountNumber })),
      ];
    },
    individualOrdersEnabled: {
      get() {
        return (
          this.orderFrom !== 'Absolute|0.00:00:00.false'
            || this.orderTo !== 'Absolute|0.00:00:00.false'
            || this.cancelTo !== 'Absolute|0.00:00:00.false'
        );
      },
      set(v) {
        this.orderFromEnabled = false;
        this.orderToEnabled = false;
        this.cancelToEnabled = false;

        this.$nextTick(() => {
          if (!v) {
            this.orderFrom = 'Absolute|0.00:00:00.false';
            this.orderTo = 'Absolute|0.00:00:00.false';
            this.cancelTo = 'Absolute|0.00:00:00.false';
          } else {
            this.orderFrom = '';
            this.orderTo = '';
            this.cancelTo = '';
          }
        });
      },
    },
    photo() {
      if (!this.listing.photo) return '';
      return `${process.env.VUE_APP_BASE_URL}/shop/${this.catalogDetails.id}/listings/${this.listing.id}/photo`;
    },
    subCatalogOrder() {
      return this.catalogDetails.subCatalogs.reduce((acc, curr) => {
        acc[curr.subCatalogId] = curr.ordinal;
        return acc;
      }, {});
    },
    subCatalogsSorted() {
      return this.catalogDetails.subCatalogs
        .filter((x) => x.subCatalogId !== '#products')
        .sort((a, b) => a.ordinal - b.ordinal)
        .map((x) => ({
          ...x,
          nodes: this.assignments
            .filter(({ subCatalogId }) => subCatalogId === x.subCatalogId)
            .map(({ nodeId, subCatalogId }) => {
              if (subCatalogId === '#groups') {
                const group = this.groups.find((g) => g.code === nodeId);
                if (!group) return null;
                return {
                  nodeId: group.code,
                  name: group.code === '#all' ? this.$t('company.all') : group.path,
                };
              }

              return this.catalogDetails.subCatalogNodes
                .filter((n) => n.subCatalogId === x.subCatalogId)
                .find((s) => s.nodeId === nodeId);
            })
            .filter((n) => n)
            .sort((a, b) => {
              if (x.subCatalogId === '#groups') {
                return a.name.localeCompare(b.name);
              }

              return a.ordinal - b.ordinal;
            }),
        }));
    },
  },
  watch: {
    limitCountEnabled(v) {
      if (v) {
        if (this.limitCount < 0) {
          this.limitCount = 1;
        }
      } else {
        this.limitCount = -1;
      }
    },
    orderFromEnabled(v) {
      if (!v) {
        this.orderFrom = '';
      }
    },
    orderToEnabled(v) {
      if (!v) {
        this.orderTo = '';
      }
    },
    cancelToEnabled(v) {
      if (!v) {
        this.cancelTo = '';
      }
    },
    file(f) {
      if (f) {
        this.removePhoto = false;
        this.$refs.photo.src = URL.createObjectURL(f);
        this.$refs.photoWrapper.style.display = 'block';
      }
    },
  },
  methods: {
    ...mapActions(['getFormDefinitions']),
    ...mapActions('shop', [
      'getProducts',
      'createCatalogListing',
      'updateCatalogListing',
      'setListingPhoto',
      'getCalendarRules',
    ]),
    cancelRuleEdit() {
      this.addingRule = false;
      this.editingRule = null;
    },
    loadRules() {
      if (!this.listing) return;
      this.rulesPending = true;
      this.rulesError = false;
      this.getCalendarRules({ params: { catalogId: this.catalogDetails.id } })
        .then(({ data }) => {
          this.listingRules = data.filter((r) => r.offerId === this.listing.id);
        })
        .catch(() => {
          this.rulesError = true;
        })
        .finally(() => {
          this.rulesPending = false;
        });
    },
    removeRule(rule) {
      axios
        .delete(`/calendar/${this.catalogDetails.id}/rules/${rule.id}?offerId=${rule.offerId}`)
        .then(() => this.loadRules());
    },
    formatWeekDay(weekDay) {
      const days = ['Niedziela', 'Poniedziałek', 'Wtorek', 'Środa', 'Czwartek', 'Piątek', 'Sobota'];
      return days[weekDay] || weekDay;
    },
    formatHour(minutes) {
      const hour = Math.floor(minutes / 60)
        .toString()
        .padStart(2, '0');
      const minute = (minutes % 60).toString().padStart(2, '0');
      return `${hour}:${minute}`;
    },
    productName(id) {
      if (id === '#new') {
        return this.name || this.$t('shop.listing.addSameAsListing');
      }
      return this.products.find((x) => x.id === id)?.name;
    },
    subCatalogName(nodeId) {
      const node = this.getNode(nodeId);
      if (node && node.subCatalogId === '#groups') {
        return this.$t('groups.groups');
      }
      return this.catalogDetails.subCatalogs.find((x) => x.subCatalogId === node?.subCatalogId)?.name;
    },
    getNode(nodeId) {
      const group = this.groups.find((x) => x.code === nodeId);
      if (group) {
        return {
          ...group,
          name: group.code === '#all' ? this.$t('company.all') : group.path,
          subCatalogId: '#groups',
        };
      }
      return this.catalogDetails.subCatalogNodes.find((x) => x.nodeId === nodeId);
    },
    removeNode(id) {
      this.assignments = this.assignments.filter((x) => x.nodeId !== id);
    },
    removeProduct(id) {
      this.productIds = this.productIds.filter((x) => x !== id);
    },
    save() {
      if (this.listing && this.isLoweringSubscriptionLimit()) {
        this.$bvModal
          .msgBoxConfirm(this.$t('shop.listing.limitCountLowerWarning'), {
            title: this.$t('shop.listing.limitCountLowerWarningTitle'),
            okVariant: 'danger',
            okTitle: this.$t('general.confirm'),
            cancelTitle: this.$t('general.cancel'),
          })
          .then((confirmed) => {
            if (confirmed) {
              this.pending = true;
              this.update();
            }
          });
        return;
      }

      this.pending = true;
      if (this.listing) {
        this.update();
      } else {
        this.create();
      }
    },
    isLoweringSubscriptionLimit() {
      if (!this.subscription.enabled) {
        return false;
      }

      const previousLimit = this.listing.countLimit;
      const newLimit = this.limitCountEnabled ? Number(this.limitCount) : -1;

      if (newLimit === -1) {
        return false;
      }

      return previousLimit === -1 || newLimit < previousLimit;
    },
    update() {
      this.updateCatalogListing({
        params: {
          catalogId: this.catalogDetails.id,
          listingId: this.listing.id,
        },
        data: {
          name: this.name,
          description: this.description,
          price: this.price,
          priceType: this.priceType,
          currency: this.currency,
          productIds: this.productIds.filter((x) => x !== '#new'),
          orderFrom: this.orderFrom || '',
          orderTo: this.orderTo || '',
          cancelTo: this.cancelTo || '',
          assignments: this.assignments,
          countLimit: this.limitCount,
          form: this.formId || '',
          fields: this.fields,
          vatCode: this.vatCode,
          accountingCode: this.accountingCode || null,
          billingCategoryId: this.billingCategoryId,
          accountNumber: this.accountNumber,
          subscription: {
            enabled: this.subscription.enabled,
            subscribeTo: this.subscription.subscribeToEnabled ? this.subscription.subscribeTo : '',
            subscribeFrom: this.subscription.subscribeFromEnabled ? this.subscription.subscribeFrom : '',
            unsubscribeTo: this.subscription.unsubscribeToEnabled ? this.subscription.unsubscribeTo : '',
            applyAt: this.subscription.applyAt,
            includeUntil: this.subscription.includeUntilEnabled ? this.subscription.includeUntil : '',
          },
        },
      })
        .then(() => {
          this.uploadPhoto(this.listing.id).finally(() => {
            this.$emit('close');
          });
        })
        .finally(() => {
          this.pending = false;
        });
    },
    uploadPhoto(listingId) {
      if (!this.file && !this.removePhoto) return Promise.resolve();

      const formData = new FormData();
      formData.append('file', this.removePhoto ? null : this.file);

      return this.setListingPhoto({
        params: {
          catalogId: this.catalogDetails.id,
          listingId,
        },
        data: formData,
      });
    },
    create() {
      this.createCatalogListing({
        params: {
          catalogId: this.catalogDetails.id,
        },
        data: {
          name: this.name,
          description: this.description,
          price: this.price,
          priceType: this.priceType,
          currency: this.currency,
          productIds: this.productIds,
          orderFrom: this.orderFrom || '',
          orderTo: this.orderTo || '',
          cancelTo: this.cancelTo || '',
          assignments: this.assignments,
          countLimit: this.limitCount,
          fields: this.fields,
          form: this.formId || '',
          vatCode: this.vatCode,
          accountingCode: this.accountingCode || null,
          billingCategoryId: this.billingCategoryId,
          accountNumber: this.accountNumber,
          subscription: {
            enabled: this.subscription.enabled,
            subscribeTo: this.subscription.subscribeToEnabled ? this.subscription.subscribeTo : '',
            subscribeFrom: this.subscription.subscribeFromEnabled ? this.subscription.subscribeFrom : '',
            unsubscribeTo: this.subscription.unsubscribeToEnabled ? this.subscription.unsubscribeTo : '',
            applyAt: this.subscription.applyAt,
            includeUntil: this.subscription.includeUntilEnabled ? this.subscription.includeUntil : '',
          },
        },
      })
        .then(({ data }) => {
          this.$emit('close');

          this.uploadPhoto(data.id).finally(() => {
            this.$emit('close');
          });

          this.getProducts({
            params: {
              catalogId: this.catalogDetails.id,
            },
          });
        })
        .finally(() => {
          this.pending = false;
        });
    },
  },
  created() {
    this.getFormDefinitions().then(({ data }) => {
      this.forms = data.filter((x) => x.type === 'ShopListing');
    });

    if (this.listing) {
      this.name = this.listing.name;
      this.description = this.listing.description;
      this.price = this.listing.price;
      this.currency = this.listing.currency;
      this.productIds = this.listing.productIds;
      this.fields = { ...this.listing.fields };
      this.assignments = this.listing.assignments
        .filter(
          (x) =>
            this.catalogDetails.subCatalogs.find((y) => y.subCatalogId === x.subCatalogId)
              && this.catalogDetails.subCatalogNodes.find((y) => y.nodeId === x.nodeId),
        )
        .slice();
      this.orderFrom = this.listing.orderFrom;
      this.orderFromEnabled = !!this.listing.orderFrom;
      this.orderTo = this.listing.orderTo;
      this.orderToEnabled = !!this.listing.orderTo;
      this.cancelTo = this.listing.cancelTo;
      this.cancelToEnabled = !!this.listing.cancelTo;
      this.limitCount = this.listing.countLimit;
      this.formId = this.listing.form || null;
      this.limitCountEnabled = this.listing.countLimit !== -1;
      this.priceType = this.listing.priceType || 'Total';
      this.vatCode = this.listing.vatCode || null;
      this.accountingCode = this.listing.accountingCode || '';
      this.billingCategoryId = this.listing.billingCategoryId || null;
      this.accountNumber = this.listing.accountNumber || null;

      if (this.listing.subscription && this.listing.subscription.enabled) {
        this.subscription.enabled = true;
        this.subscription.subscribeToEnabled = !!this.listing.subscription.subscribeTo;
        this.subscription.subscribeFromEnabled = !!this.listing.subscription.subscribeFrom;
        this.subscription.unsubscribeToEnabled = !!this.listing.subscription.unsubscribeTo;
        this.subscription.includeUntilEnabled = !!this.listing.subscription.includeUntil;
        this.subscription.applyAt = this.listing.subscription.applyAt;
        this.subscription.subscribeTo = this.listing.subscription.subscribeTo;
        this.subscription.subscribeFrom = this.listing.subscription.subscribeFrom;
        this.subscription.unsubscribeTo = this.listing.subscription.unsubscribeTo;
        this.subscription.includeUntil = this.listing.subscription.includeUntil;
      }
    }
  },
};
</script>

<style lang="scss" scoped>
  .tab-bar {
    border-bottom: 1px solid #efefef;
    margin-bottom: 12px;
  }

  .tab-item {
    padding: 6px 14px;
    cursor: pointer;
    font-size: 0.9rem;
    color: #888;
    border-bottom: 2px solid transparent;
    margin-bottom: -1px;

    &:hover {
      color: #333;
    }

    &.active {
      color: $blue;
      font-weight: 500;
      border-bottom-color: $blue;
    }
  }

  .rule-row {
    padding: 7px 10px;
    border: 1px solid #eee;
    border-top: none;
    font-size: 0.88rem;

    &:first-of-type {
      border-top: 1px solid #eee;
    }

    .secondary-icon {
      cursor: pointer;
      color: #bbb;

      &:hover {
        color: $red;
      }
    }
  }

  .product-name {
    font-size: 20px;
    font-weight: 500;
    line-height: 1.3;
    padding-top: 15px;
  }

  .photo {
    max-height: 150px;
    max-width: 150px;
  }

  .photo-wrapper {
    width: 150px;
    height: 150px;
    min-width: 150px;
    min-height: 150px;
    border: 1px solid #efefef;
    border-radius: 5px;
    overflow: hidden;
    text-align: center;
    margin-right: 20px;
  }

  .switch {
    max-width: 10px;
    padding-left: 2.5rem;
    position: relative;
    right: -1rem;
    top: -1px;
  }

  .form-box {
    padding: 5px 10px 10px;
    border: 1px solid #efefef;
  }

  .product-row {
    display: flex;
    align-items: center;
    margin-top: 7px;
    background-color: #fafafa;
    border-radius: 15px;
  }
</style>
